module.exports = "<div class=\"container\">\r\n\t<h1>Chybička se vloudila</h1>\r\n\t<p>\r\n\t\tOmlouváme se Vám, bohužel cílový server není dostupný.\r\n\t</p>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/p0.component.html
// module id = 465
// module chunks = 11